<template>
    <welcome-box>
        <password-email />
    </welcome-box>
</template>

<script>
import WelcomeBox from '@/components/WelcomeBoxOld.vue';
import PasswordEmail from '@/components/PasswordReset/PasswordEmail.vue';

export default {
    components: {
        WelcomeBox,
        PasswordEmail,
    },
};
</script>
